<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="fb-form">

            <el-form-item label="部门名称" prop="fullName" :error="formErrorMsg.fullName" class="fb-form-item">
                <el-input v-model="formData.fullName"></el-input>
            </el-form-item>

            <el-form-item label="部门简称" prop="shortName" :error="formErrorMsg.shortName" class="fb-form-item">
                <el-input v-model="formData.shortName"></el-input>
            </el-form-item>


            <el-form-item label="部门编号" prop="number" :error="formErrorMsg.number" class="fb-form-item">
                <el-input v-model="formData.number"></el-input>
            </el-form-item>

            <el-form-item label="部门类型" prop="type" :error="formErrorMsg.type" class="fb-form-item">
                <dict-select type-flag="DEPARTMENT_TYPE" v-model="formData.type"></dict-select>
            </el-form-item>


            <el-form-item label="上级部门" prop="parentCode" :error="formErrorMsg.parentCode" class="fb-form-item" >
                <org-cascader v-model="formData.parentCode"></org-cascader>
            </el-form-item>


            <el-form-item label="所在区域" prop="areaCode" :error="formErrorMsg.areaCode" class="fb-form-item">
                <area-cascader area-type="ACS_AREA" v-model="formData.areaCode"></area-cascader>
            </el-form-item>


            <el-form-item label="信用代码" prop="sucCode" :error="formErrorMsg.sucCode" class="fb-form-item">
                <el-input v-model="formData.sucCode"></el-input>
            </el-form-item>


            <el-form-item label="机构代码" class="fb-form-item">
                <el-input v-model="formData.orgCode"></el-input>
            </el-form-item>


            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>



    import AreaCascader from "../../components/AreaCascader";
    import DictSelect from "../../components/DictSelect";
    import OrgCascader from "../../components/OrgCascader";
    export default {
        name: "OrgAdd",
        components: {OrgCascader, DictSelect, AreaCascader},
        data() {
            return {
                api:{
                    add:this.$api.department.add
                },
                formErrorMsg:{
                    fullName:'',
                    shortName:'',
                    number:'',
                    parentCode:'',
                    areaCode:'',
                    sucCode:'',
                    orgCode:'',
                },
                formData: {
                    fullName:'',
                    shortName:'',
                    number:'',
                    parentCode:'',
                    areaCode:'',
                    sucCode:'',
                    orgCode:'',
                },
                rules: {
                    fullName: [
                        {required: true, message: '请输入部门名称', trigger: 'blur'},
                    ],
                    type: [
                        {required: true, message: '请选择部门类型', trigger: 'blur'},
                    ],
                    number: [
                        {required: true, message: '请输入部门编号', trigger: 'blur'},
                    ]

                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.add,vm.$qs.stringify(this.formData)).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                if(window.handleAddChildDept){
                                    vm.formData.code = resp.data.data.code;
                                    window.handleAddChildDept(vm.formData);
                                }
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){

                                console.log(vm.$refs[form]);


                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(()=>{
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });

                                if(resp.data.desc){
                                    vm.$message({
                                        type:"error",
                                        message: resp.data.desc
                                    });
                                }


                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },
        created() {
           let vm = this;
           if(vm.$route.query.parentCode){
               vm.formData.parentCode = vm.$route.query.parentCode;
           }

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }

</style>